<template>
  <el-dialog
    title="动态属性编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <!-- <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form> -->
    <el-form
      :model="formData"
      :rules="rules"
      label-width="130px"
      ref="formData"
    >
      <el-form-item label="序号" prop="sort">
        <el-input v-model="formData.sort"></el-input>
      </el-form-item>

      <el-form-item label="事项类型" prop="itemType">
        <el-select clearable v-model="formData.itemType">
          <el-option
            v-for="item in itemList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="事项名称" prop="itemName">
        <el-input clearable v-model="formData.itemName"> </el-input>
      </el-form-item>
      <el-form-item label="检测结果类型" prop="resultType">
        <el-radio-group
          v-model="formData.resultType"
          size="small"
          @change="handleClick"
        >
          <el-radio :label="1" border>选择</el-radio>
          <el-radio :label="2" border>判定</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="检测结果默认值" prop="resultValue">
        <el-select clearable v-model="formData.resultValue" v-if="resultSelect">
          <el-option
            v-for="item in resultList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="formData.resultValue"
          type="select"
          v-else
        ></el-input>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <!-- <el-input v-model="formData.status"></el-input> -->
        <el-radio-group v-model="formData.status" size="small">
          <el-radio :label="1" border>启用</el-radio>
          <el-radio :label="2" border>禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="结果判定脚本" prop="scriptId">
        <el-select clearable v-model="formData.scriptId">
          <el-option
            v-for="item in scriptList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否在第一页显示" prop="shows">
        <!-- <el-input v-model="formData.status"></el-input> -->
        <el-radio-group v-model="formData.shows" size="small">
          <el-radio :label="0" border>是</el-radio>
          <el-radio :label="1" border>否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否是保证项" prop="qualifiedType">
        <!-- <el-input v-model="formData.status"></el-input> -->
        <el-radio-group v-model="formData.qualifiedType" size="small">
          <el-radio :label="1" border>是</el-radio>
          <el-radio :label="0" border>否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="button-group" style="display: flex; justify-content: center">
        <el-button
          type="primary"
          style="width: 185px; margin: 0 20px"
          class="form-button"
          @click="submitFn"
        >
          <span>确定</span>
        </el-button>
      </div>
    </el-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
import { scriptList } from '@/api/scriptis'
import { queryEquipment } from '@/api/dictionary'

export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    row: Object,
    roles: Array
  },

  data() {
    return {
      resultSelect: true,
      formData: {
        // qualifiedType: 1
        // status: 1,
        // shows: 0,
        // attributeLabel: 1
      },
      itemList: [],
      resultList: [],
      scriptList: [],
      rules: {
        sort: [{ required: true, message: '序号必填', trigger: 'blur' }],
        itemType: [
          { required: true, message: '事项类型必填', trigger: 'blur' }
        ],
        itemName: [{ required: true, message: '事项名称必填', trigger: 'blur' }]
      },
      // 表单配置
      formConfig: [
        {
          label: '设备类型',
          field: 'deviceType',
          type: 'select',
          payload: [],
          rules: [{ required: true, message: '设备类型必填', trigger: 'blur' }]
        },
        {
          label: '模板类型',
          field: 'templateType',
          type: 'select',
          payload: [],
          rules: [{ required: true, message: '模板类型必填', trigger: 'blur' }]
        },
        {
          label: '属性名',
          field: 'attributeName',
          type: 'text',
          rules: [{ required: true, message: '属性名必填', trigger: 'blur' }]
        },
        {
          label: '属性标签',
          field: 'attributeLabel',
          type: 'text',
          rules: [{ required: true, message: '属性标签必填', trigger: 'blur' }]
        },
        {
          label: '状态',
          field: 'status',
          type: 'radio',
          radiolist: [
            {
              value: 1,
              label: '启用'
            },
            {
              value: 2,
              label: '禁用'
            }
          ]
          // rules: [{ required: true, message: '仪器型号必填', trigger: 'blur' }]
        }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  created() {
    // this.formConfig.status = 1
    console.log(this.formConfig)
    this.queryEquipmentFn()
    this.getScriptList()
  },
  watch: {
    // row(newData) {
    //   console.log("watch", newData);
    // },
    row: {
      handler(newData) {
        console.log(newData)
        if (!newData) return
        this.formData = newData
        if (this.formData.resultType === 1) {
          this.resultSelect = true
        } else if (this.formData.resultType === 2) {
          this.resultSelect = false
        }
      },
      immediate: true
    }
  },
  methods: {
    //获取类型
    queryEquipmentFn() {
      let types = ['check_resultValue', 'check_itemType']
      queryEquipment(types).then((res) => {
        console.log(res.data, '类型')
        this.itemList = res.data.check_itemType
        this.resultList = res.data.check_resultValue
      })
    },
    // 获取检测项判定脚本列表
    getScriptList() {
      let params = {
        pageSize: -1
      }
      scriptList(params).then((res) => {
        if (res.code == 200) {
          let scriptArr = res.data.records
          this.scriptList = scriptArr.map((item) => {
            return {
              value: item.id,
              label: item.scriptName
            }
          })
        }
      })
    },
    // 监听radio框变化
    handleClick(val) {
      this.formData.resultValue = ''
      console.log(val)
      if (val === 1) {
        this.resultSelect = true
      } else if (val === 2) {
        this.resultSelect = false
      }
    },
    handleClose() {
      this.$emit('close')
    },
    submitFn() {
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          this.$emit('confirm', this.formData)
        }
      })
      console.log('更新数据处理', this.formData)
    }
  }
}
</script>

<style></style>
